export const CONFIG = {

  //url: 'http://192.168.3.36:71/',    
  //url_socket: 'http://192.168.3.36:71/notify',

  url: 'https://api.infofactperu.pe/',
  url_socket: 'https://api.infofactperu.pe/notify',
  versionApi: 'api',

  // --- URLs anteriores comentadas ---
  // url_externaAuth: "https://sweb3.grupotsiperu.com.pe:8905/erp/",
  // versionApi_externaAuth: 'api',
  // url_externa: "https://apipublic.grupotsiperu.com.pe:8911/",
  // versionApi_externa: 'api',
  // url_externa: "https://public.api.gtsi.pe/",
  // versionApi_externa: 'api/external',

  // --- Nueva configuración API Pública ERP TSI (URL base https://public.api.gtsi.pe/) ---
  url_externaAuth: "https://public.api.gtsi.pe/",
  versionApi_externaAuth: 'api/external',
  // Base de consultas: https://public.api.gtsi.pe/api/external/consultas
  url_externa: "https://public.api.gtsi.pe/",
  versionApi_externa: 'api/external/consultas',

  url_Cloud: "https://cloudservices.infomatica.pe/",
  versionApi_cloud: 'api',
};
